import { create } from 'zustand'
import { useDataStore } from './dataStore'

export type DTCategory = 'instance' | 'aggregate'
export type DTInstanceType = 'sensor' | 'equipment' | 'system' | 'process'

interface DigitalTwin {
  id: string
  name: string
  category: DTCategory
  type?: DTInstanceType
  dataSource?: string
  parentId?: string
  children?: string[]
}

interface DTStore {
  digitalTwins: DigitalTwin[]
  addDigitalTwin: (dt: Omit<DigitalTwin, 'id'>) => void
  getDataSources: () => string[]
  getInstances: () => DigitalTwin[]
}

export const useDTStore = create<DTStore>((set, get) => ({
  digitalTwins: [],
  addDigitalTwin: (dt) => set((state) => ({
    digitalTwins: [...state.digitalTwins, { ...dt, id: Date.now().toString() }]
  })),
  getDataSources: () => {
    const datasets = useDataStore.getState().datasets
    return datasets.map(dataset => dataset.name)
  },
  getInstances: () => get().digitalTwins.filter(dt => dt.category === 'instance')
})) 